export const ignitePrompts = [
  {
    text: `I'm Searching for Attachments`,
    children: [
      {
        text: `Help me Find the Right Fit`,
        parentText: "I'm Searching for Attachments"
      },
      {
        text: `Speak to an Attachments Expert`,
        parentText: "I'm Searching for Attachments"
      }
    ]
  },
  {
    text: `I'm Searching for Parts`,
    children: [
      {
        text: `Submit Bulk Parts Request`,
        parentText: "I'm searching for Parts"
      },
      {
        text: `Help me Find the Right Fit`,
        parentText: "I'm searching for Parts"
      },
      {
        text: `Speak to a Parts Expert`,
        parentText: "I'm Searching for Parts"
      }
    ]
  },
  {
    text: `I'm Searching for Implements`,
    children: [
      {
        text: `Help me Find the Right Fit`,
        parentText: "I'm searching for Implements"
      },
      {
        text: `Speak to an Implements Expert`,
        parentText: "I'm searching for Implements"
      }
    ]
  },
  {
    text: `I Need Help With My Order`,
    children: [
      {
        text: `Help With a Return`,
        parentText: 'I Need Help With My Order',
        children: [
          {
            text: `That Helped`,
            parentText: 'Help With a Return'
          },
          {
            text: `Speak to a team member`,
            parentText: 'Help With a Return'
          }
        ]
      },
      {
        text: `Help Tracking my Order`,
        parentText: 'I Need Help With My Order'
      }
    ]
  },
  {
    text: `Interested In Reselling`
  },
  {
    text: `Something Else`,
    children: [
      {
        text: `Contact Information`,
        parentText: 'Something Else',
        children: [
          {
            text: `That Helped`,
            parentText: 'Contact Information'
          },
          {
            text: `Speak to a team member`,
            parentText: 'Contact Information'
          }
        ]
      },
      {
        text: `Submit a Warranty Claim`,
        parentText: 'Something Else',
        children: [
          {
            text: `That Helped`,
            parentText: 'Submit a Warranty Claim'
          },
          {
            text: `Speak to a team member`,
            parentText: 'Submit a Warranty Claim'
          }
        ]
      },
      {
        text: `Find a Reseller`,
        parentText: 'Something Else',
        children: [
          {
            text: `That Helped`,
            parentText: 'Find a Reseller'
          },
          {
            text: `Speak to a team member`,
            parentText: 'Find a Reseller'
          }
        ]
      }
    ]
  }
]
